import { defineStore } from "pinia";
import { api } from "@/helpers/api.js";
import { todayISODate } from "@/helpers/format";
import { formatISODate } from "../helpers/format.js";

export const useTeamsStore = defineStore("teams", {
  state: () => ({
    data: null,
    loading: false,
    query: {},
  }),
  getters: {
    teams() {
      if (!this.data) {
        this.data = [];
        this.fetch();
      }
      return this.data;
    },
    ready() {
      return this.teams && this.req;
    },
  },
  actions: {
    fetch() {
      const params = new URLSearchParams({
        page_size: 9999,
      });
      this.loading = true;
      this.req = api
        .cache("/teams?" + params)
        .then((res) => {
          this.data = res.data.teams.map((team) => ({
            ...team,
            uc: team.official_name.toUpperCase() + " " + team.sport_type + " " + team.sport_type_name,
          }));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getTeam(slug) {
      for (const team of this.teams) {
        if (team.slug === slug) {
          return team;
        }
      }
    },
    get_popular(query, next) {
      query.sport_type = query.sport_type.replace("football", "soccer");
      const params = new URLSearchParams({
        page_size: 9999,
        popular: true,
        event_startdate: "ge:" + todayISODate,
        ...query,
      });
      params.delete("country");
      api
        .cache("/teams?" + params)
        .then((res) => res.data.teams)
        .then((teams) => teams.filter((team) => (query.country ? team.iso_country === query.country : true)))
        .then(next);
    },
    search(payload) {
      const params = {
        page_size: 5,
        popular: true,
      };
      const searchParams = new URLSearchParams(params);
      if (payload.isoCountry) {
        searchParams.append("iso_country", payload.isoCountry);
      }
      if (payload.sportType) {
        searchParams.append("sport_type", payload.sportType);
      }
      if (payload.startDate) {
        searchParams.append("event_startdate", payload.startDate);
      }
      return api.cache("/teams?" + searchParams).then((res) => {
        return res.data;
      });
    },

    async numeventsbyteams(query, next) {
      if (query.sport_type === "football") query.sport_type = "soccer";
      if (query.sport_type === "") delete query.sport_type;
      const params = new URLSearchParams({
        stats_profile: "events_per_hometeam",
        ...query,
      });
      const req = api.cache("events/statistics?" + params);
      const res = await req;
      next(res);
    },

    fetchTeams(payload) {
      const params = {
        event_startdate: `gt:${formatISODate(new Date())}`,
        sport_type: "soccer",
      };
      const searchParams = new URLSearchParams(params);
      if (payload.isoCountry) {
        searchParams.append("iso_country", payload.isoCountry);
      }
      return api.get("/teams?" + searchParams).then((res) => {
        return res.data.teams;
      });
    },
  },
});
